import { NotificationProvider } from "./notification";
import { z } from "./utils/zod";

export const TargetingNotificationPolicies = [
  "DISABLED",
  "STAGE_UPDATES_ONLY",
  "ALL_CHANGES",
] as const;

export const TargetingNotificationPolicySchema = z.enum(
  TargetingNotificationPolicies,
);

export type TargetingNotificationPolicy = z.infer<
  typeof TargetingNotificationPolicySchema
>;

export function policyAllowsTargetingNotification(
  policy: TargetingNotificationPolicy,
  stageChanged = false,
): boolean {
  return (
    policy === "ALL_CHANGES" ||
    (policy === "STAGE_UPDATES_ONLY" && stageChanged)
  );
}

export function defaultTargetingNotificationPolicyForProvider(
  provider: NotificationProvider,
): TargetingNotificationPolicy {
  return provider === "slack" ? "ALL_CHANGES" : "STAGE_UPDATES_ONLY";
}

export function defaultTargetingNotificationPolicies(): Record<
  NotificationProvider,
  TargetingNotificationPolicy
> {
  return {
    slack: defaultTargetingNotificationPolicyForProvider("slack"),
    linearComment:
      defaultTargetingNotificationPolicyForProvider("linearComment"),
  };
}
